// extracted by mini-css-extract-plugin
module.exports = {"tickets":"Tickets_tickets__2ftWz","tickets__boxes":"Tickets_tickets__boxes___gD1z","table":"Tickets_table__3mmpk"};